module.exports = __webpack_public_path__ + "static/media/Santiago.6e0d299c.svg";